import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'
import { RootLayout } from './layouts/RootLayout'
import { DashboardLayout } from './layouts/DashboardLayout'
import { AuthLayout } from './layouts/AuthLayout'

// Dashboard pages
import { DashboardPage } from './pages/dashboard'
import { SchoolsPage } from './pages/schools'
import { NewSchoolPage } from './pages/schools/new'
import { SchoolDetailPage } from './pages/schools/[schoolId]'
import { EditSchoolPage } from './pages/schools/[schoolId]/edit'
import { CreateSchedulePage } from './pages/schools/[schoolId]/schedules/create'
import { ScheduleDetailPage } from './pages/schools/[schoolId]/schedules/[scheduleId]'
import { MapPage } from './pages/map'
import { UsersPage } from './pages/users'
import { DocsPage } from './pages/docs'

// Auth pages
import { LoginPage } from './pages/auth/v2/login'

// Other pages
import { UnauthorizedPage } from './pages/unauthorized'
import { NotFoundPage } from './pages/not-found'
import { ExternalPage } from './pages/external'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
          {
            path: 'schools',
            children: [
              {
                index: true,
                element: <SchoolsPage />,
              },
              {
                path: 'new',
                element: <NewSchoolPage />,
              },
              {
                path: ':schoolId',
                children: [
                  {
                    index: true,
                    element: <SchoolDetailPage />,
                  },
                  {
                    path: 'edit',
                    element: <EditSchoolPage />,
                  },
                  {
                    path: 'schedules',
                    children: [
                      {
                        path: 'create',
                        element: <CreateSchedulePage />,
                      },
                      {
                        path: ':scheduleId',
                        element: <ScheduleDetailPage />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: 'map',
            element: <MapPage />,
          },
          {
            path: 'users',
            element: <UsersPage />,
          },
          {
            path: 'docs',
            element: <DocsPage />,
          },
        ],
      },
      {
        path: 'auth',
        element: <AuthLayout />,
        children: [
          {
            path: 'v2/login',
            element: <LoginPage />,
          },
        ],
      },
      {
        path: 'unauthorized',
        element: <UnauthorizedPage />,
      },
      {
        path: 'external',
        element: <ExternalPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
])
